import { render } from "./purchaseList.vue?vue&type=template&id=1dc82e57&scoped=true"
import script from "./purchaseList.vue?vue&type=script&lang=js"
export * from "./purchaseList.vue?vue&type=script&lang=js"

import "./purchaseList.vue?vue&type=style&index=0&id=1dc82e57&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1dc82e57"

export default script